import type {
    GlobalCatalogItem,
    GlobalCategorization,
} from '../model/types/CatalogItemSchema';

export function getGlobalCatalogCategorization(
    item: GlobalCatalogItem,
): GlobalCategorization {
    const { category: c } = item;

    if (c.parentCategory) {
        return {
            catId: c.parentCategory.uid,
            subCatId: c.uid,
        };
    }

    if (c.parentUid) {
        return {
            catId: c.parentUid,
            subCatId: c.uid,
        };
    }

    return {
        catId: c.uid,
        subCatId: undefined,
    };
}
